import { classNames } from "../../utils"
import {
  VerticalAligned,
  type VerticalAlignedProps,
} from "../VerticalAligned/VerticalAligned"

export type CenterAlignedProps = VerticalAlignedProps

/**
 * Aligns its children vertically and horizontally.
 */
export function CenterAligned({ className, ...rest }: CenterAlignedProps) {
  return (
    <VerticalAligned
      className={classNames("items-center", className)}
      {...rest}
    />
  )
}
